module.exports = __webpack_public_path__ + "images/social-icons/facebook-icon.9b4ae2b19d783a1b334b.svg";